import React from "react"
import PropTypes from "prop-types"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Packages from "../components/packages"
import SubheaderCovid from "../components/subheader-covid"

import download from "../images/works-with/download.svg"
import speakers from "../images/works-with/speakers.svg"
import water from "../images/works-with/water.svg"
import lighting from "../images/works-with/lighting.svg"
import thermostat from "../images/works-with/thermostat.svg"
import locks from "../images/works-with/locks.svg"

class WorksWithPage extends React.Component {
  render() {
    return (
      <Layout className="works-with">
        <SEO title="Available Smart Home Integrations" />
        <div className="hero">
          <div className="hero__header">BrightSuite Works With</div>
        </div>
        <div className="subhero">
          <p className="subhero__header t7">See the full list of compatible devices</p>
          <a className="cta" target="_blank" href="https://brightsuite-static.s3.amazonaws.com/pdf/works_with.pdf">
            <img src={download} />
            Model List
          </a>
        </div>
        <div className="categories">
          <div className="category">
            <div className="image">
              <img src={speakers} alt="Speaker" />
            </div>
            <div className="info">
              <div className="info__header t11">Smart Speakers and Voice Controls</div>
              <div className="info__desc t5 t5--loose">
                Change the temperature or turn on your lights with a simple voice command—you can even have your favorite song play when you walk through the front door.
              </div>
              <ul className="info__list">
                <li>Amazon Alexa</li>
                <li>Google Home</li>
                <li>Siri Shortcuts</li>
                <li>Sonos ®</li>
              </ul>
              <a href="/faq/#speakers" className="info__cta cta">Learn More</a>
            </div>
          </div>
          <div className="category">
            <div className="image">
              <img src={thermostat} alt="Thermostat" />
            </div>
            <div className="info">
              <div className="info__header t11">Smart Thermostats</div>
              <div className="info__desc t5 t5--loose">
                Control your Z-Wave thermostat from the bed or the beach.
              </div>
              <ul className="info__list">
                <li>Trane</li>
                <li>Stelpro</li>
                <li>Linear</li>
                <li>Radio Thermostat</li>
              </ul>
              <a href="/faq/#thermostats" className="info__cta cta">See List</a>
            </div>
          </div>
          <div className="category">
            <div className="image">
              <img src={locks} alt="Door lock" />
            </div>
            <div className="info">
              <div className="info__header t11">Smart Locks</div>
              <div className="info__desc t5 t5--loose">
                No more hiding keys under the doormat—spare keys are a thing of the past with access codes and remote unlocking capabilities.
              </div>
              <ul className="info__list">
                <li>Yale (Z-Wave)</li>
                <li>Kwickset (Z-Wave)</li>
                <li>Schlage (Z-Wave)</li>
              </ul>
              <a href="/faq/#locks" className="info__cta cta">See List</a>
            </div>
          </div>
          <div className="category">
            <div className="image">
              <img src={lighting} alt="Lamp on table" />
            </div>
            <div className="info">
              <div className="info__header t11">Smart Lighting</div>
              <div className="info__desc t5 t5--loose">
                Never come home to a dark house again, with Z-Wave lights that can be scheduled to turn on at sunset or when the video doorbell rings.
              </div>
              <ul className="info__list">
                <li>Leviton</li>
                <li>Jasco</li>
                <li>GoControl</li>
                <li>Linear</li>
                <li>GE</li>
                <li>Zipato</li>
              </ul>
              <a href="/faq/#lighting" className="info__cta cta">See List</a>
            </div>
          </div>
          <div className="category">
            <div className="image">
              <img src={water} alt="Washing Machine" />
            </div>
            <div className="info">
              <div className="info__header t11">Smart Irrigation and Water Control</div>
              <div className="info__desc t5 t5--loose">
                Our irrigation and water control partners make sure your vacation won't be dampened by worries about leaky sinks or thirsty houseplants.
              </div>
              <ul className="info__list">
                <li>WaterCop</li>
                <li>FortrezZ</li>
                <li>Rachio</li>
                <li>Rainbird</li>
              </ul>
              <a href="/faq/#water" className="info__cta cta">See List</a>
            </div>
          </div>
        </div>

        <Packages />
      </Layout>
    )
  }
}

export default WorksWithPage
